export default __webpack_public_path__ + "static/media/loading-background.f9903685.png";